import React from 'react'
import useStyles from '../styles'

interface HighlightTextProps {
  text: string
  query: string
}

function escapeRegExp(value: string): string {
  return value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
}

const HighlightText: React.FC<HighlightTextProps> = ({ text, query }) => {
  const classes = useStyles()
  const trimmed = query.trim()

  if (trimmed === '') return <>{text}</>

  const regex = new RegExp(`(${escapeRegExp(trimmed)})`, 'ig')
  const parts = text.split(regex)

  return (
    <>
      {parts.map((part, i) =>
        // Odd indices are the captured matches (split with a capturing group
        // interleaves matches between the surrounding text).
        i % 2 === 1 ? (
          <mark
            key={i}
            className={classes.highlightMark}
          >
            {part}
          </mark>
        ) : (
          <React.Fragment key={i}>{part}</React.Fragment>
        ),
      )}
    </>
  )
}

export default HighlightText
